import { useT } from "../../i18n";

interface HeroProps {
  /** Background photo. Falls back to a flat tone while you have no asset. */
  imageUrl?: string;
}

export default function Hero({ imageUrl }: HeroProps) {
  const t = useT();
  return (
    <section className="relative h-95 overflow-hidden bg-[#E9EAEB] sm:h-115 lg:h-135">
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={t.home.heroImageAlt}
          fetchPriority="high"
          className="absolute inset-0 h-full w-full object-cover"
        />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center bg-linear-to-b from-[#F4F4F4] to-[#D9DADC]">
          <span className="font-mono text-xs text-faint">{t.home.heroPhoto}</span>
        </div>
      )}

      {/* Readability scrim behind the copy */}
      <div className="absolute inset-x-0 top-0 h-56 bg-linear-to-b from-white/85 to-transparent" />

      <div className="pointer-events-none absolute inset-x-0 top-0 px-5 pt-14 text-center sm:pt-20 backdrop-blur-xs sm:backdrop-blur-none">
        <h1 className="m-0 text-3xl font-medium tracking-[-0.01em] text-ink sm:text-3xl lg:text-5xl">
          {t.home.heroTitle}
        </h1>
        <p className="mx-auto mt-3 max-w-140 text-sm leading-relaxed text-black sm:text-base ">
          {t.home.heroText}
        </p>
      </div>
    </section>
  );
}
